import * as React from "react";
import "./Companies.css";
import { ReactComponent as EditSvg } from "../../../../assets/Icons/edit (1).svg";
import { ReactComponent as DeleteSvg } from "../../../../assets/Icons/Delete _ Default.svg";

export default function CompanyDrawer({
  editDepHandler,
  index,
  setCompanyId,
  setDrawer,
  setDeleteOpen,
  setCompanyName,
  companyName,
  canDelete = false,
}) {
  const editbtnHandler = () => {
    setCompanyId(index);
    setDrawer?.(0);
    editDepHandler();
  };

  const deletebtnHandler = () => {
    if (!canDelete) return;
    setCompanyId(index);
    setCompanyName?.(companyName || "");
    setDrawer?.(0);
    setDeleteOpen?.(true);
  };

  return (
    <>
      <div className="companyDrawerActive">
        <p onClick={editbtnHandler}>
          <EditSvg style={{ width: "15px" }} />
          Edit
        </p>
        {canDelete ? (
          <p onClick={deletebtnHandler}>
            <DeleteSvg style={{ width: "15px" }} /> Delete
          </p>
        ) : null}
      </div>
    </>
  );
}
